<template>
    <CHeader fixed with-subheader light>
        <!-- Mobile Sidebar Toggler -->
        <CToggler in-header class="d-lg-none" @click="$store.commit('toggleSidebarMobile')" />
    
        <!-- Desktop Sidebar Toggler -->
        <CToggler in-header class="ml-3 d-md-down-none" @click="$store.commit('toggleSidebarDesktop')" />
    
        <!-- Brand Logo (Mobile only) -->
        <CHeaderBrand class="mx-auto d-lg-none" :to="{ path: '/' }">
            <img src="../assets/img/logobig.png" height="30" alt="Pickiddo Logo" />
        </CHeaderBrand>
    
        <!-- Navigation (Desktop only) -->
        <CHeaderNav class="d-md-down-none mr-auto">
            <CHeaderNavItem class="px-3">
                <!-- <CHeaderNavLink :to="{ path: '/dashboard' }">Pages / Dashboard</CHeaderNavLink> -->
            </CHeaderNavItem>
        </CHeaderNav>
    
        <!-- User Profile & Sign Out -->
        <CHeaderNav class="mr-4">
            <CHeaderNavItem class="d-md-down-none mx-2">
    
                <CHeaderNavLink style="cursor: pointer;">
                    <!-- <div class="input-container mr-2">
                        <img src="../assets/img/search.png" alt="search icon" class="icon-left" />
                        <input type="text" placeholder="Search..." />
                        <img src="../assets/img/filter.png" alt="command icon" class="icon-right" />
                    </div> -->
                    <!-- <img
                    :src="user.FilePath ? getPic(user) : require('../assets/img/default.png')"
                    :style="user.FilePath ? profileStyle : defaultStyle"
                    class="grey lighten-2"
                    alt="User Avatar"
                  /> -->
                    <h6>Explore with Flyhigh</h6>
                    <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
                        <template #toggler>
              <CHeaderNavLink>
                <div class="c-avatar">
                  <img
                    :src="user.FilePath ? getPic(user) : require('../assets/img/default.png')"
                    :style="user.FilePath ? profileStyle : defaultStyle"
                    class="grey lighten-2"
                    alt="User Avatar"
                  />
                </div>
              </CHeaderNavLink>
</template>
<CDropdownItem @click="GoToProfile()">
      <CIcon name="cil-user" :href="Profile"/> Profile
    </CDropdownItem>
    <CDropdownItem @click="SignOut">
      <CIcon name="cil-lock-locked" @click="SignOut"/> Logout
    </CDropdownItem>
  </CDropdown>
        
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>

  </CHeader>
</template>

<script>
export default {
    name: "TheHeader",
    data() {
        return {
            user: {},
            defaultStyle: {
                border: "1px solid #eee",
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                objectFit: "cover"
            },
            profileStyle: {
                border: "3px solid #ddd",
                background: "#fff",
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                objectFit: "cover"
            }
        };
    },
    mounted() {
        this.GetProfilePicture();
    },
    methods: {
        GetProfilePicture() {
            this.$API.get(this.$ViewProfilePictureAdmin, { withCredentials: true })
                .then(response => {
                    if (response.status === 200 && response.data) {
                        this.user = response.data;
                    }
                })
                .catch(error => {
                    console.error("Error fetching profile:", error);
                });
        },
        SignOut() {
            this.$API.get(this.$SignOut, { withCredentials: true })
                .then(response => {
                    if (response.status === 200) {
                        localStorage.removeItem("affiliateReportAuth");
                        this.$router.push("/Login");
                    }
                })
                .catch(error => {
                    console.error("Sign out failed:", error);
                });
        },
        getPic(user) {
            return `https://www.flyhigh.my/${user.FilePath}`;
        },
        GoToProfile()
        {
            this.$router.push("ProfileTuitionCenter");
        }
    }
};
</script>